'use strict';

export const version:string = "2.0.0";
export const DATABASE_DATE_FORMAT:string = "yyyy-MM-dd H:mm:ss";
export const PREFIX_FC_BAYERN_LABEL = "FC Bayern";
export const FC_BAYERN_LOGO = "fc_bayern_logo";
export const PREFIX_DFB_LABEL = "Deutschland";
export const DFB_LOGO= "Deutschland";
export const BLACKLIST_REDIRECT_URL= "/blacklist";
export const STAMMDATEN_REDIRECT_URL= "/stammdaten";
export const AGBS_REDIRECT_URL= "/compliance";
export const SPIEL_ART_1BL = "1.BL";
export const SPIEL_ART_2BL = "2.BL";
export const SPIEL_ART_INTERNATIONAL = "International";
export const SPIEL_ART_NATIONAL= "National";
export const SPIEL_ART_SONSTIGES= "Sonstiges";
